<template>
    <nav class="navbar navbar-default navbar-fixed-top navbar-inverse">
        <div class="container">
            <div class="navbar-header">
                <button type="button"
                        class="navbar-toggle collapsed"
                        aria-expanded="false"
                        v-on:click.prevent="toggleMenu">
                   <span class="sr-only">Afficher le menu</span>
                   <span class="icon-bar"></span>
                   <span class="icon-bar"></span>
                   <span class="icon-bar"></span>
                </button>

                <a class="navbar-brand"
                   v-link="{'name': 'home'}">
                    Gescomi 2
                </a>
            </div>

            <div class="collapse navbar-collapse"
                 v-bind:class="{in: menuUnfolded}"
                 v-if="showMenu">
                <ul class="nav navbar-nav">
                    <li v-link-active v-if="isStaff || partnerCode">
                        <a v-link="{name: 'home', activeClass: 'active', exact: true}">
                            Accueil
                        </a>
                    </li>
                    <li v-link-active v-if="isStaff || partnerCode">
                        <a v-link="{name: 'clients', activeClass: 'active'}">
                            Membres
                        </a>
                    </li>
                    <li v-link-active v-if="isStaff">
                        <a v-link="{name: 'document-types', activeClass: 'active'}">
                            Documents
                        </a>
                    </li>
                    <li v-link-active v-if="isStaff">
                        <a v-link="{name: 'sheet-list', activeClass: 'active'}">
                            Bordereaux
                        </a>
                    </li>
                </ul>

                <ul class="nav navbar-nav navbar-right">
                    <li :class="{'-has-new': todoIsNew}"
                        class="nav-todo-count"
                        v-if="todoCount && (isStaff || partnerCode)"
                        v-link-active>
                        <a v-link="{name: 'todo-list', activeClass: 'active'}">
                            <i class="fa fa-bell"
                               aria-hidden="true"></i>
                            <span>{{ todoCount }}</span>
                        </a>
                    </li>
                    <li>
                        <a
                            href="#"
                            v-on:click.prevent="logout"
                            data-testid="logout-button"
                        >
                            Déconnexion
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

    <router-view></router-view>

    <div class="alerts">
        <div class="container">
            <alerts></alerts>
        </div>
    </div>
</template>

<style src="./style/bootstrap.less" lang="less"></style>
<style src="font-awesome/css/font-awesome.css"></style>
<style src="./style/fbox.less" lang="less"></style>
<style src="./style/utils.less" lang="less"></style>
<style src="./directives/drop-zone.less" lang="less"></style>

<style lang="less" type="text/less">
    @import '~src/style/variables';

    body {
        padding-top: 83px;
    }

    .alerts {
        position: fixed;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 100;
    }

    .nav-todo-count {
        &.-has-new {
             a {
                 color: @brand-danger !important;
             }
        }

        a {
            padding-left: 36px !important;
        }
    }

    i.fa-bell-o,
    i.fa-bell {
        position: absolute;
        font-size: 16px;
        left: 16px;
        top: 22px;
    }
</style>

<script type="text/ecmascript-6">
    import api from './api/core';
    import router from './router';
    import {getCount, getSeen, setSeen, todoBus} from './api/todo';
    import Alerts from './components/Alerts';

    export default {
        components: {
            Alerts
        },
        data() {
            return {
                todoCount: 0,
                todoSeen: getSeen(),
                todoLatest: null,
                todoSeeLatest: false,
                showMenu: api.isAuthenticated(),
                menuUnfolded: false,
                isStaff: api.isStaff(),
                partnerCode: api.getPartnerCode()
            };
        },
        ready() {
            api.onAuthStatusChange((status) => {
                this.$data.showMenu = status;
                this.$data.isStaff = api.isStaff();
                this.$data.partnerCode = api.getPartnerCode();
                this.updateTodo();
            });

            router.afterEach(() => {
                this.$data.menuUnfolded = false;
            });

            todoBus.$on('see-latest', (seen) => {
                if (!this.todoLatest) {
                    this.todoSeeLatest = true;
                } else {
                    this.todoSeen = this.todoLatest;
                    setSeen(this.todoLatest);
                }
            });

            todoBus.$on('update-count', () => {
                this.updateTodo();
            });

            this.updateTodo();
            setInterval(this.updateTodo, 60000);
        },
        computed: {
            todoIsNew() {
                return this.todoLatest !== this.todoSeen;
            }
        },
        methods: {
            logout: api.logout,
            toggleMenu() {
                this.$data.menuUnfolded = !this.$data.menuUnfolded;
            },
            updateTodo() {
                if (!api.isAuthenticated()) {
                    return;
                }

                getCount().then((data) => {

                    this.todoCount = data.todo;
                    this.todoLatest = data.latest;

                    if (this.todoSeeLatest) {
                        this.todoSeeLatest = false;
                        this.todoSeen = data.latest;
                        setSeen(data.latest);
                    }
                }).catch((e) => {
                    return;
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// App.vue?06df2c28